export default function Reputation() {
  const testimonials = [
    {
      name: '张先生',
      role: '91n资深用户',
      content: '使用91n官方入口导航已经两年了，每次入口地址更新都能第一时间在这里找到，非常可靠。推荐给了很多朋友，大家都说好用。',
      rating: 5,
    },
    {
      name: '李女士',
      role: '91n活跃用户',
      content: '新手指南写得特别详细，我一开始什么都不懂，跟着教程一步步操作很快就上手了。感谢91n官方入口提供的优质服务。',
      rating: 5,
    },
    {
      name: '王同学',
      role: '91n忠实粉丝',
      content: '安全指南写得非常专业，帮我避免了很多网络陷阱。91n官方入口是我每次访问91n的必经之路，收藏夹里永远置顶。',
      rating: 5,
    },
    {
      name: '赵先生',
      role: '互联网从业者',
      content: '作为从业者，我很欣赏91n官方入口的专业态度。内容质量高，更新及时，对用户需求的把握很到位。值得信赖的平台。',
      rating: 5,
    },
    {
      name: '陈女士',
      role: '91n新用户',
      content: '刚接触91n的时候有点迷茫，好在有这个导航站帮我快速找到了正确的入口和详细的使用教程，大大降低了学习成本。',
      rating: 5,
    },
    {
      name: '刘先生',
      role: '91n长期用户',
      content: '91n官方入口的FAQ板块解决了我大部分疑问，分类清晰，查找方便。遇到问题先来这里看看基本上都能搞定。',
      rating: 5,
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-foreground-900 mb-3">
            用户口碑
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            听听用户们对91n官方入口的真实评价
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t, index) => (
            <div key={index} className="bg-background-50 rounded-lg p-6">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm text-primary-400" />
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                &ldquo;{t.content}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 text-sm font-semibold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                  <div className="text-xs text-foreground-400">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}